// src/Shared/Store/Store.tsx
import { create } from 'zustand';
import { ApiResponse } from '../Data/apiResponse';
import { IStoreState } from './IStoreState';

export const useStore = create<IStoreState>((set, get) => ({

  selectedItem: [],

  accounts: new ApiResponse<any[]>(),
  setAccounts: (accounts: ApiResponse<any[]>) => set({ accounts }),


  setSelectedItem: (item) => set({ selectedItem: item }),
  
  resetSelectedItems: () => set({ selectedItem: [] }),


  //Handling form validation data
  formValidations:[],
  setFormValidations: (formValidations: any[])=> set({ formValidations }),

  showAttachment: false,
  setShowAttachment: (status: boolean) => set({showAttachment: status}),
}));
